<template>
  <div class="page-header-wrapper">
    <div class="page-header translucent-wrapper" v-bind:style="headerStyle">
      <input type="file" id='photo' @change='loadPreview' hidden ref="loadPreviewButton"/>

      <div class="advantage-addition">
        <img src="/static/img/icons/delete.svg" class="delete-icon" 
          @click="deleteBondedLoanLetter(letterObject.id)"
        />

        <div class="centered ispdf">
          <b-switch v-model='isPDF'>Это pdf</b-switch>
        </div>

        <b-field>
          <b-input placeholder="Заголовок" v-model="letter.title" 
            @change="updateBondedLoanLetter(letter)"
          ></b-input>
        </b-field>

        <div v-if="this.letter.type === 'pdf'">
          <div class="centered">
            <span class="button-wrapper" @click="handleLoadPreview">
              <a class="button is-info">+</a>Загрузить превью
            </span>
          </div>

          <div class="centered">
            <span class="button-wrapper" v-if="!letterObject.file" 
              @click="handleloadDocument"
            >
              <a class="button is-info">+</a>Загрузить документ
            </span>
            
            <span v-else class="rates-file">
              <a target="_blank" :href="'/' + letterObject.file">
                Просмотреть документ
              </a>
              
              <img src="/static/img/icons/delete.svg" 
                class="delete-icon" @click="deleteFile"
              />
            </span>
            
            <input type="file" @change='loadDocument' hidden ref="loadDocumentButton"/>
          </div>
        </div>

        <div v-else>
          <div class="centered">
            <span class="button-wrapper" @click="handleLoadPreview">
              <a class="button is-info">+</a>Загрузить фото
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import deepcopy from 'deepcopy'

  export default {
    name: 'Letter',

    data () {
      return {
        base64photo: ''
      }
    },

    props: {
      letter: {
        type: Object,
        required: true
      }
    },

    computed: {
      letterObject () {
        return deepcopy(this.letter)
      },

      isPDF: {
        get () {
          return this.letter.type === 'pdf'
        },
        set (val) {
          if (val) {
            this.letter.type = 'pdf'
          } else {
            this.letter.type = 'img'
          }
          this.$forceUpdate()
        }
      },

      headerStyle () {
        if (this.letter.preview || this.base64photo) {
          if (!this.base64photo.length) {
            return { background: `url(/upload/photos/${this.letter.preview})` }
          } else {
            return {background: `url(${this.base64photo})`}
          }
        } else {
          return {background: ''}
        }
      }
    },

    methods: {
      ...mapActions(['deleteBondedLoanLetter', 'updateBondedLoanLetter',
        'changeBondedLoanLetterFile']),

      loadPreview (e) {
        const reader = new FileReader()
        reader.readAsDataURL(e.target.files[0])
        reader.onload = (ee) => {
          this.base64photo = ee.target.result
          this.$forceUpdate()
        }
        const formData = new FormData()
        const file = e.target.files[0]
        formData.set('avatar', file)
        this.letterObject.newPreview = formData
        this.updateBondedLoanLetter(this.letter)
        this.letter.newPreview = formData
      },

      handleLoadPreview () {
        this.$refs.loadPreviewButton.click()
      },

      setType (val) {
        this.$forceUpdate()
      },

      loadDocument (e) {
        const formData = new FormData()
        const file = e.target.files[0]
        formData.set('document', file)
        this.letterObject.newFile = formData
        this.letter.newFile = formData
        this.changeBondedLoanLetterFile({id: this.letter.id, file: file.name, newFile: formData})
      },

      deleteFile () {
        this.letterObject.newFile = null
        this.changeBondedLoanLetterFile({file: '', id: this.letterObject.id})
      },

      handleloadDocument () {
        this.$refs.loadDocumentButton.click()
      }
    }
  }
</script>

<style>
.advantage-addition-wrapper {
  background: #eeeeee;
  padding: 30px;
  margin: 20px 0px;
}

.advantage-addition, .service-description {
  max-width: 600px;
  margin: 0 auto;
  position: relative;
}

.delete-icon {
  width: 24px;
  position: absolute;
  top: -20px;
  right: -20px;
  z-index: 100;
  cursor: pointer;
}

.space-evenly {
  justify-content: space-evenly;
}

.page-header {
  margin: 0;
}

.ispdf {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// Letter.vue?2b7720c6